import React, { useEffect, useState } from "react";
import { Bell } from "lucide-react";
import { useCookies, withCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";

// Pass in unread count if you want it managed elsewhere (i.e. notifications screen)
const NotificationMenuComponent = ({ api, unreadCount }) => {

    const [cookies] = useCookies()
    const [isOpen, setIsOpen] = useState(false);
    const [notifications, setNotifications] = useState([]);

    const navigate = useNavigate()

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const [count, setCount] = useState(unreadCount ?? 0)

    useEffect(() => {
        if (unreadCount !== undefined) {
            setCount(unreadCount)
        } else {
            setCount(notifications.filter((notif) => !notif.read).length)
        }
    }, [unreadCount, notifications])

    const markAsReadAndNavigate = async (notif) => {
        if (!notif.read) {
            try {
                await api().markNotificationsAsRead(cookies.token, notif.id)
            } catch (e) {
                
            }
        }
        navigate(`/user/${notif.username}`)
    }

    useEffect(() => {
        (async () => {
            try {
                const resp = await api().fetchNotifications(cookies.token)
                if (resp.status === 200) {
                    const mappedNotificaitons = resp.data.map((notif) => ({
                        id: notif._id,
                        text: notif.text,
                        username: notif.actionableUsername,
                        read: notif.read
                    }))
                    setNotifications(mappedNotificaitons)
                }
            } catch (error) {
                console.log(error.message)
            }
        })()
    }, [])

    return (
        <div className="relative">
            {/* Bell Icon */}
            <button
                className="relative hover:text-gray-400"
                onClick={toggleMenu}
            >
                <Bell className="w-6 h-6 mt-1" />
                {count > 0 && (
                    <span className="absolute top-0 right-0 block w-4 h-4 bg-red-500 text-white text-xs rounded-full flex items-center justify-center">
                        {count}
                    </span>
                )}
            </button>

            {/* Notification Dropdown */}
            {isOpen && (
                <div className="absolute right-0 mt-8 w-64 bg-white rounded-lg shadow-lg border border-gray-200 z-10">
                    <div className="p-4 border-b border-gray-200 clickable" onClick={() => {
                        navigate("/notifications")
                        setIsOpen(false)
                    }} >
                        <h3 className="text-sm font-semibold text-gray-700">Notifications</h3>
                    </div>
                    <ul className="max-h-64 overflow-y-auto">
                        {notifications.length > 0 ? (
                            notifications.map((notif) => (
                                <li
                                    key={notif.id}
                                    className={`p-3 text-sm ${notif.read ? "text-gray-500" : "text-gray-800 font-semibold"
                                        } hover:bg-gray-100 cursor-pointer`}
                                    onClick={async () => markAsReadAndNavigate(notif)}
                                >
                                    {notif.text}
                                </li>
                            ))
                        ) : (
                            <li className="p-3 text-sm text-gray-500">No notifications</li>
                        )}
                    </ul>
                    <button
                        className="w-full text-center text-sm text-blue-500 py-2 border-t border-gray-200 hover:bg-gray-50"
                        onClick={() =>
                            navigate("/notifications")
                        }
                    >
                        See all
                    </button>
                </div>
            )}
        </div>
    );
};

const NotificationMenu = withCookies(({ api, unreadCount }) => (
    <NotificationMenuComponent api={api} unreadCount={unreadCount} />
))

export default NotificationMenu;
